import { render, staticRenderFns } from "./Conclusions.vue?vue&type=template&id=a45bedc8&"
import script from "./Conclusions.vue?vue&type=script&lang=js&"
export * from "./Conclusions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports